import { IconButton } from "@mui/material";
import React, { ReactElement } from "react";

import { useCommonTranslation } from "@dfp/react-common-translation";
import { IconXClose } from "@dfp/react-icons";

export type DialogCloseReason = "backdropClick" | "escapeKeyDown" | "iconClick";

type Props = {
  onClose: (
    event: React.MouseEvent<HTMLButtonElement>,
    reason: "iconClick",
  ) => void;
};

export function AppDialogCloseButton({ onClose }: Props): ReactElement {
  const { commonTT } = useCommonTranslation();

  return (
    <IconButton
      aria-label={commonTT("Button.close")}
      sx={(theme) => ({
        position: "absolute",
        top: theme.spacing(4),
        right: theme.spacing(4),
        zIndex: 99,
      })}
      onClick={(event) => {
        onClose(event, "iconClick");
        event.preventDefault();
      }}
      variant="text"
      size="small"
    >
      <IconXClose />
    </IconButton>
  );
}
